import React from 'react';
import Register from 'components/website/auth/Register';

function RegisterPage() {
  return <Register />;
}

export default RegisterPage;
